import { toppingSortedByParentId } from '../utils';

import type { ToppingToPrint } from 'features/print-management/order-invoice-printing';

export function useToppingsByParentId(props: Props) {
  const { toppings } = props;

  const toppingsSorted = toppingSortedByParentId(toppings);

  return {
    toppingsSorted,
  };
}

interface Props {
  toppings: ToppingToPrint[];
}
